import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { ExternalFulfillmentService, RequestedService, ShipFrom } from '../../../../configure-shipment/fields';

const ExternalFulfillmentConfiguration = memo(({ fulfillmentPlanId }) => {
  return (
    <>
      <RequestedService fulfillmentPlanId={fulfillmentPlanId} />
      <ShipFrom fulfillmentPlanId={fulfillmentPlanId} />
      <ExternalFulfillmentService />
    </>
  );
});

ExternalFulfillmentConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export { ExternalFulfillmentConfiguration };
